import React from 'react';
import { Link } from 'react-router-dom';
import Sponsor from '../Components/SponsorCard/SponsorCard';
import useSiteContent, { imageUrl, safeLink } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const Sponsors = () => {
  const { data, unavailable } = useSiteContent('sponsors');
  return <div className="main_page_container">
    <ContentNotice unavailable={unavailable} />
    <h1 className="page_title">Our Sponsors</h1>
    <div className="sponsor_grid">
      {data.items.map((sponsor, index) => <Sponsor key={index} {...sponsor} image={imageUrl(sponsor.image)} link={safeLink(sponsor.link)} />)}
    </div>
    <div className="sponsor_reg_button_container">
      <Link to="/become_a_sponsor" className="sponsor_reg_button">Become an HPS Sponsor</Link>
    </div>
  </div>;
};
export default Sponsors;
